import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[awAlertActions]',
    standalone: true,
})
export class AlertActionsDirective {
    constructor(public template: TemplateRef<any>) {}
}
